// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"seo-page_mainSection__G1FBq","cta":"seo-page_cta__F8_Wa"};